import(/* webpackMode: "eager", webpackExports: ["CartView"] */ "/vercel/path0/app/(frontend)/panier/cart-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageHero"] */ "/vercel/path0/components/sections/page-hero.tsx");
